export default [
  {
    path: "/customer/createOrder",
    name: "CreateOrder",
    meta: {
      title: "下单支付",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/customer/createOrder")
  },
  {
    path: "/customer/customerCenter",
    name: "CustomerCenter",
    meta: {
      title: "用户中心",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/customer/customerCenter")
  },
  {
    path: "/customer/offlinePay",
    name: "OfflinePay",
    meta: {
      title: "线下打款",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/customer/offlinePay")
  },
  {
    path: "/customer/orderDetail",
    name: "OrderDetail",
    meta: {
      title: "订单详情",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/customer/orderDetail")
  },
  {
    path: "/customer/orderAudioVideo",
    name: "OrderAudioVideo",
    meta: {
      title: "音视频资料",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/customer/orderAudioVideo")
  },
  {
    path: "/customer/orderAddMember",
    name: "OrderAddMember",
    meta: {
      title: "添加成员",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/pages/customer/orderAddMember")
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/customer.js